import React, { useEffect, useState } from "react";
import pdfViewIcon from "../../assets/images/pdfViewIcon.svg";
import downArrow from "../../assets/images/downArrow.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import NoDataFound from "../NoDataFound/NoDataFound";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { getProductListHandler } from "../../redux/action/getProductList";
import { getItem, setItem } from "../../common/localStorage";

const ProductInfo = () => {
  const [pdfUrl, setPdfUrl] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const getAdminId = getItem("adminId");


  useEffect(() => {
    if (getAdminId) {
      let payload = {
        userId: getAdminId,
        refBrandId: 1,
      };
      dispatch(getProductListHandler(payload));
    }
  }, [getAdminId]);

  useEffect(() => {
    const url = state?.item?.content?.file?.url;
    if (url) {
      setPdfUrl(url);
    } else {
      console.error("PDF URL is invalid or missing");
    }
  }, [state]);

  return (
    <>
      {state?.item?.content?.type === "pdf_url" && pdfUrl ? (
        <div className="container">
          <div className="pdfViewer">
            <div className="mx-887 mx-auto h-100">
              <Worker
                workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}
              >
                <Viewer fileUrl={pdfUrl}  />
              </Worker>
            </div>
          </div>
        </div>
      ) : !state?.item?.content?.type ||
        state?.item?.content?.componants?.length === 0 ? (
        <NoDataFound />
      ) : state?.item?.content?.type === "Dpcextra" ? (
        <div className="mainSection container">
          <div className="dashboardGrid dpcExtra">
            {state?.item?.content?.componants?.map((item, index) => {
              return (
                <div
                  className="dashboardCard"
                  onClick={() =>
                  {

                    navigate("/dpcextra", {
                      state: { itemData: item, stateDashboard: state },
                    })
                    setItem("innerFeature",item?.name)
                  }
                  }
                  key={index}
                >
                  <img
                    src={item?.iconUrl}
                    alt=""
                    className="mb-16 featureImage"
                  />
                  <div className="gb fs-20 fw-600">{item?.name}</div>
                  <img src={downArrow} alt="" className="redirectArrow" />
                </div>
              );
            })}
          </div>
        </div>
      ) : state?.item?.content?.type === "html" ? (
        <>
          <div className="container py-50 mobileMargin">
            <iframe
              title="Dynamic Content"
              className="iframeheight"
              srcDoc={state?.item?.content?.html?.html_content}
              style={{
                width: "100%",
                border: "none",
              }}
            />
          </div>
        </>
      ) : state?.item?.content?.type === "multi_pdf" ? (
        <div className="mainSection container">
          <div className="dashboardGrid dpcExtra">
            {state?.item?.content?.files?.map((item, index) => {
              return (
                <div
                  className="dashboardCard"
                  onClick={() =>
                    navigate("/explanation-of-benifits-history", {
                      state: { itemData: item, stateDashboard: state },
                    })
                  }
                  key={index}
                >
                  <img
                    src={pdfViewIcon}
                    alt=""
                    className="mb-16 featureImage"
                  />
                  <div className="gb fs-20 fw-600">{item?.fileName}</div>
                  <img src={downArrow} alt="" className="redirectArrow" />
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <NoDataFound />
      )}
    </>
  );
};

export default ProductInfo;
